import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FaRegEdit, FaRegTrashAlt } from 'react-icons/fa';
import styles from '../Dashboard.module.css';
import ConfirmationModal from '../../components/dashboard/ConfirmationModal';

const Projects = () => {
    const { projects, handleOpenForm, handleDeleteProject } = useOutletContext();
  const [isModalOpen, setModalOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);

  const openConfirmationModal = (projectId) => {
    setProjectToDelete(projectId);
    setModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setProjectToDelete(null);
    setModalOpen(false);
  };

  const confirmDeletion = () => {
    if (projectToDelete) {
      handleDeleteProject(projectToDelete);
      closeConfirmationModal();
    }
  };

  

  return (
    <section id="projects" className={styles.dataSection}>
      <header className={styles.header}>
        <h2>Gestion des Projets</h2>
        <button onClick={() => handleOpenForm()} className={styles.addButton}>+ Ajouter un projet</button>
      </header>
      <div className={styles.tableContainer}>
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Image</th>
              <th>Titre</th>
              <th>Catégorie</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects.map(project => (
              <tr key={project.id}>
                <td>
                  {project.coverImageUrl && (
                    <img 
                      src={project.coverImageUrl}
                      alt={`Couverture de ${project.title}`}
                      className={styles.thumbnail} 
                    />
                  )}
                </td>
                <td>{project.title}</td>
                <td>{project.category || 'N/A'}</td>
                <td>{project.project_date ? new Date(project.project_date).toLocaleDateString() : 'N/A'}</td>
                <td className={styles.actions}>
                  <button onClick={() => handleOpenForm(project)} className={styles.edit} title="Modifier le projet" aria-label="Modifier">
                    <FaRegEdit size={18} />
                  </button>
                                    <button onClick={() => openConfirmationModal(project.id)} className={styles.delete} title="Supprimer le projet" aria-label="Supprimer">
                    <FaRegTrashAlt size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeConfirmationModal}
        onConfirm={confirmDeletion}
        title="Confirmer la suppression"
      >
        Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est irréversible.
      </ConfirmationModal>
    </section>
  );
};

export default Projects;
